import { gql } from 'apollo-boost'

const SCRAPING_TEST_CASE_RESULTS = gql`
  query scrapingTestCaseResults(
    $scrapingSessionId: ID!
    $page: Int
    $pageSize: Int
  ) {
    scrapingTestCaseResults(scrapingSessionId: $scrapingSessionId, page: $page, pageSize: $pageSize) {
      scrapingTestCaseResults {
        id
        outcome
        scrapingResponse {
          id
          type
          response
        }
        scrapingTestCase {
          id
          menuId
          menuUrl
          scrapingInstructions
          scrapedData
          tags {
            id
            name
            type
          }
        }
        newDishes
        missingDishes
        newMenuTitles
        missingMenuTitles
      }
      total
    }
  }
`

export default SCRAPING_TEST_CASE_RESULTS


